import React from 'react';
import { useHistory } from 'react-router-dom';
import { Col, Container, Row } from 'reactstrap';
import RoutesConst from '../../blocks/consts/RoutesConst';
import I18n from '../../blocks/localization';
import promet_logo_white from '../../assets/images/promet-logo-white.png';

const Footer = () => {
    const history = useHistory();

    const redirect = (route: string) => {
        history.push(route);
    }
    
    return (
        <footer>
            <Container fluid>                
            <Row>
                    <Col md={12}>
                        <span className='text-center'>{I18n.t('euro.rate')}</span>
                    </Col>
                </Row>            
                <Row>
                    <Col md={10}>
                        <span>{I18n.t('footer.footerText')}</span>
                        <span id="footer-links">                            
                            <span onClick={() => redirect(RoutesConst.TermsOfUse)} className="mr-3">{I18n.t('footer.termsOfUse')}</span>
                            <span onClick={() => redirect(RoutesConst.Contact)}>{I18n.t('footer.contact')}</span>
                        </span>
                    </Col>
                    <Col md={2} id="footerLogo">
                        <img src={promet_logo_white} alt="promet-logo" />
                    </Col>
                </Row>
            </Container>
        </footer>
    );
}

export default Footer;
